import { Component } from '@angular/core';

@Component({
  selector: 'app-argalis-apps-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent {}
